import { FC, useState, ReactElement, cloneElement } from 'react';
import cn from 'classnames';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';
import ThemeDropdown, { ThemeDropdownProps } from '@base/lib/ThemeDropdown';
import HeaderBarTrigger, { HeaderBarTriggerProps } from '@app/common/PageHeader/HeaderBarTrigger';
import { useStoreState } from 'base/store';

export type HeaderBarMenuProps = {
    onClose?: () => void;
};

type HeaderBarDropdownProps = Omit<ThemeDropdownProps, 'overlay'> & {
    triggerProps: HeaderBarTriggerProps;
    menu: ReactElement;
    alignRight?: boolean
};

const HeaderBarDropdown: FC<HeaderBarDropdownProps> = props => {
    const [open, setOpen] = useState<boolean>(false);
    const { ua: { isMobile } } = useStoreState('rootStore');
    const { triggerProps, menu, alignRight = false, overlayClassName, ...rest } = props;

    const onClose = () => setOpen(false);

    const getContainer = () => document.getElementById('js-header-bar-scope') as HTMLDivElement;

    return (
        <ThemeDropdown
            content={
                <div className={cn(styles['widget-menu-wrap'], 'g-widget-menu-wrap')}>
                    {cloneElement(menu, {
                        onClose
                    })}
                </div>
            }
            align={{
                offset: [0, 0],
                overflow: { adjustX: false, adjustY: false }
            }}
            trigger={[isMobile ? 'click' : 'hover']}
            open={open}
            onOpenChange={setOpen}
            placement="bottomLeft"
            getPopupContainer={getContainer}
            overlayClassName={cn(overlayClassName, styles['widget-overlay'], { [styles['widget-overlay-right']]: alignRight })}
            showArrow={false}
            {...rest}
        >
            <HeaderBarTrigger arrow {...triggerProps}/>
        </ThemeDropdown>
    )
}


export default HeaderBarDropdown;
